export default {
  apiKey: "AIzaSyCQSF-LV8l5NXBgUeC-mCk4fbSMf9SFyGw",
  authDomain: "scc-db.firebaseapp.com",
  databaseURL: "https://scc-db.firebaseio.com",
  projectId: "scc-db",
  storageBucket: "gs://scc-db.appspot.com",
  messagingSenderId: "746234280903",
  appId: "1:746234280903:web:45c66aea5f6975bd"
};
